export const listOfLoginMethods = function (that) {
  let defaultLoginMethods = [
    {
      value: 'Sms',
      text: that.$t('vuetifyWidgets.dr-login.bySms')
    },
    {
      value: 'SmartId',
      text: that.$t('vuetifyWidgets.dr-login.bySmartId')
    },
    {
      value: 'DigitalCertificate',
      text: that.$t('vuetifyWidgets.dr-login.byDigitalCertificate')
    },
    {
      value: 'qr',
      text: that.$t('vuetifyWidgets.dr-login.byQrCode')
    },
    {
      value: 'defaultLogin',
      text: that.$t('vuetifyWidgets.dr-login.byPassword')
    }
  ]

  return defaultLoginMethods
}
